/* eslint-disable no-unused-vars */
import React from "react";
import { object, number } from "prop-types";

import { AdContainer } from "../../ads";

import CardImage from "../../atoms/cardimage";
import StoryHeader from "../story-header";
import StorySideBar from "../story-sidebar";

import "./cartoon.m.css";
import StorySeparator from "../../atoms/story-separator";
import StoryElements from "../story-elements";

const CartoonStoryTemplate = ({ story, index }) => {
  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} showHeroImage={false} />
            <CardImage story={story} aspectRatio={[9, 16]} imageType={"image9x16"} renderedWidth={720} widths={[700]} />
            <StoryElements story={story} cards={story.cards.slice(1)} index={index} />
            <div styleName="ad-wrapper" className="hide-desktop">
              <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1675837489260-0" mobile="PV_MWeb_AP_Top" />
            </div>
            <div styleName="ad-wrapper" className="hide-mobile">
              <AdContainer
                AdClassName="standard-970x90"
                id="div-gpt-ad-1675837241937-0"
                desktop="PV_Desktop_AP_Leaderboard_Bottom"
              />
            </div>
          </div>
        </div>
        <div className="side-story-section">
          <StorySideBar index={index} story={story} />
        </div>
      </div>
    </>
  );
};

CartoonStoryTemplate.propTypes = {
  story: object,
  index: number
};

const CartoonStory = (props) => {
  return <CartoonStoryTemplate story={props.story} index={props.index} />;
};

CartoonStory.propTypes = {
  story: object,
  index: number
};

export default CartoonStory;
